import api from "./api.config";
const list = (params) => {
    
    return api
        .get(`/api/admin/subscription/packages`, {
            params
        })
        .then((response) => {
            return response.data;
        });
}

const listAsOptions = () => {
    
    return list({
        limit: 100,
        page: 1
    }).then((response) => {
        const options = response.data.map(plan => ({
            key: plan.id,
            value: plan.name?.['en']
        }));
        return options;
    });
}

const PlansService = {
    list,
    listAsOptions
};

export default PlansService;